import { EpisodeCategory } from '@common/enums/episodeCategory';
import { ServiceCode } from '@common/enums/serviceCode';
import { fetchJson } from '../store/fetch';

export async function osasExaminationCanCreateOsasq(patientId: string) {
    const lastOsasRequestForPatientResult = await fetchJson(
        `/api/requestProcesses?patientId=${patientId}&episodeCategory=${EpisodeCategory.somnology}&orderByCreatedAtDesc=true&onlyLastInCarePaths=true`,
        'GET'
    );

    if (lastOsasRequestForPatientResult.status === 200) {
        return (
            !lastOsasRequestForPatientResult.json.items.length ||
            lastOsasRequestForPatientResult.json.items[0].code !== ServiceCode.OSASQ
        );
    }
}
